import React            from 'react';

class Label extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className   = { `simprakit-dropdown-label` }>
                { p.children }
            </div>
        )
    }
}

export default Label;